<script>
import { store } from '../store/index';

export default {
  data() {
    return {
      transitionHeight: {
        previous: 0,
      },
    };
  },

  methods: {
    updateHeight(payload) {
      const element = payload.element;
      const prevHeight = `${this.transitionHeight.previous}px`;
      const nextHeight = `${payload.height}px`;

      if (this.$store.state.quiz.currentQuestion === 1) {
        this.transitionHeight.previous = payload.height;
        return;
      }

      if (prevHeight === nextHeight) {
        return;
      }

      element.style.height = prevHeight;

      setTimeout(() => {
        element.style.height = nextHeight;
      }, 10);

      element.addEventListener('transitionend', event => {
        if (event.propertyName === 'height' || event.propertyName === 'all') {
          element.style.height = '';
        }
      });

      this.transitionHeight.previous = payload.height;
    },

    /**
     * Push events to the GTM
     */
    dataLayerPush(step, log) {
      log = log || false;

      if (typeof window.dataLayer === 'undefined') {
        return;
      }

      window.dataLayer.push({
        'event': 'forms.show',
        'formType': window.croIdentifier,
        'step': step,
      });

      if (log === true) {
        console.log(window.dataLayer);
      }
    },

    scrollToSelector(id, offset = 0, callback = () => {}) {
      /**
       * Scroll to a specified selector
       * @param id
       * @param offset
       * @param callback
       */
      const element = document.querySelector(id);
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      let offsetPosition = elementPosition - (offset * -1);
      const offsetPositionFixed = offsetPosition.toFixed();
      let scrollTime = 0;
      let cancelled = false;

      const callScrollToSelectorCallback = () => {
        if (window.pageYOffset.toFixed() === offsetPositionFixed) {
          window.removeEventListener('scroll', callScrollToSelectorCallback);
          cancelled = true;
          callback();
        } else {
            const currentScrollTime = new Date().getTime();
            scrollTime = currentScrollTime;

            setTimeout(() => {
                if (!cancelled && currentScrollTime === scrollTime) {
                    window.removeEventListener('scroll', callScrollToSelectorCallback);
                    callback();
                }
            }, 150);
        }
      };

      if (typeof callback === 'function') {
        window.addEventListener('scroll', callScrollToSelectorCallback);
        callScrollToSelectorCallback();
      }

      setTimeout(() => {
        if (offsetPosition === 0) {
          offsetPosition = -1;
        }

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }, 10);
    },

    sbPopup(text, style, timer, selector) {
      //Create the popup
      var popup = document.getElementById('popup');

      if (!popup) {
        popup = document.createElement('div');
        popup.setAttribute('id', 'popup');
        popup.innerHTML =
          '<div class="popup-icon"></div>' +
          '<span></span>';

        document.body.appendChild(popup);
      }

      //Set the correct style
      style = style || 'info';

      //Initialize
      var timout = 0;
      if (popup.classList.contains('active')) {
        popup.classList.remove('active');
        timout = 600;
      }

      setTimeout(() => {
        popup.querySelector('span').innerHTML = text;
        popup.className = '';
        popup.classList.add('active');
        popup.classList.add(style);
      }, timout);


      //timer function to automatically remove the popup
      if (timer) {
        setTimeout(() => {
          popup.classList.remove('active');
        }, timer);
      }

      //A selector to scroll to when the popup is activated
      if (selector) {
        if (window.innerWidth < 950) {
          this.scrollToSelector(selector, -100);
        } else {
          this.scrollToSelector(selector, -300);
        }
      }


      //Remove the popup when clicking a form element
      [].slice.call(document.querySelectorAll('#popup, .form-info, .select, select, input, textarea, .form-row-checkbox label, .form-row-radio, label, .toggle-picker')).forEach(function (destroyPopup) {
        destroyPopup.addEventListener('click', () => {
          popup.classList.remove('active');
        });
      });
    },
  },
};
</script>
